(function sidebarCollapse() {
    $('.js-collapse').on('click touch', function(event){
        const $parent = $(event.target).closest('.js-sidebar-item');
        const $thisBox = $parent.children('.js-collapse-box');
  
        if ( !$parent.hasClass('open') ) {
            $parent.addClass('open');
            $thisBox.css({'max-height': 'unset'});
            const boxHeight = $thisBox.height();
            $thisBox.animate({maxHeight:boxHeight}, {duration: 300, easing: 'linear'});
            setTimeout(() => {
                $thisBox.css({'max-height': 'unset'});
            }, 300);
        } else {
            $thisBox.css({'max-height': 'unset'});
            const boxHeight = $thisBox.height();
            $thisBox.css({'max-height': boxHeight});
            $parent.removeClass('open');
            $thisBox.animate({maxHeight: 0}, {duration: 300, easing: 'linear'});
        }
    });
  })();  